// extracted by mini-css-extract-plugin
module.exports = {"title":"PreviewComm_title__1updK","info":"PreviewComm_info__3pHpW"};